import ListViewCtrl from "../util/ListViewCtrl";

export default class OdpocetListCtrl extends ListViewCtrl {

  static $inject = ["itemSource", "SamoodpocetService"];
  constructor(itemSource, SamoodpocetService){
    super(itemSource);
    this.selection = {};
    this.SamoodpocetService = SamoodpocetService;
  }

  selectedIds(){
    return Object.keys(this.selection).filter(k => this.selection[k]);
  }

  toggleSelection(){
    if(this.isAllSelected){
      this.selection = {};
      this.isAllSelected = false;
    }else{
      this.itemSource.result.map(item => item.id).forEach(id => this.selection[id] = true);
      this.isAllSelected = true;
    }
  }

  export(){
    this.SamoodpocetService.export();
  }



}


// WEBPACK FOOTER //
// ./src/Odpocet/OdpocetListCtrl.js